export const MAXIMUM_NUMBER_AMOUNT = 100000000

export const TOP_BANKS = [
  "Axis Bank",
  "HDFC Bank",
  "ICICI Bank",
  "State Bank of India",
];

export const UPI_INTENT_APPS = [
  {
    id: "tez",
    name: "Google Pay",
    logo: "/assets/intent/google-pay.svg",
  },
  {
    id: "PhonePe",
    name: "PhonePe",
    logo: "/assets/intent/phonepe.svg",
  },
  {
    id: "paytmmp",
    name: "Paytm",
    logo: "/assets/intent/paytm.svg",
  },
];
